module.exports = __webpack_public_path__ + "static/media/hsp_desktop.18db8d52.jpg";